var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cat-filter" },
    _vm._l(_vm.categories, function (cat) {
      return _c(
        "button",
        {
          key: cat.key,
          class: { "is-active": _vm.active === cat.key },
          on: {
            click: function ($event) {
              return _vm.$emit("change", cat.key)
            },
          },
        },
        [_vm._v(_vm._s(_vm.labelOf(cat)))]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }